exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3XrpXVfEoWZGoV_2fQB1Uo{color:\"[theme:themePrimary, default:#0078D4]\"}._27Vl7t77KpyRVQUFs8Gkxp,._13SrLzCZ4y7vuJ_BQBkYJq{display:block;color:\"[theme:neutralTertiary, default:#a6a6a6]\"}", ""]);
// Exports
exports.locals = {
	"completedIcon": "_3XrpXVfEoWZGoV_2fQB1Uo",
	"pendingIconHovered": "_27Vl7t77KpyRVQUFs8Gkxp",
	"pendingIconUnhovered": "_13SrLzCZ4y7vuJ_BQBkYJq"
};